export const mfManifestsPath = '/assets/module-federation.manifest.hot.json'
